<div class="d-flex flex-1 align-items-center justify-content-center">
  @if (securityProfiles$ | async; as securityProfiles) {
    <form class="p-3 brand-scrollbar">
      <!-- This input hidden is set so focus do not go to the first element on screen,
      that is the radio group and following W3C directives would set the focus at the first element from the radio group -->
      <input type="hidden" />
      @for (securityProfile of securityProfiles; track trackByUserOrgProfileId(i, securityProfile); let i = $index) {
        <div class="d-flex align-items-center gap-2 pb-3">
          <p-radiobutton
            [formControl]="securityProfileControl"
            [inputId]="$any(securityProfile.userOrgProfileId)"
            [value]="securityProfile"
            name="securityProfile"
          />
          <label [for]="securityProfile.userOrgProfileId" class="text-wrap">
            <span class="bold">{{ securityProfile.securityProfileName }}</span>
            ({{ securityProfile.organizationName }})
          </label>
        </div>
      }
    </form>
  }
</div>
<div class="dialog-button-container">
  <div class="mx-1">
    <p-button (click)="closeDialog()" label="Cancel" severity="secondary" />
  </div>
  <div class="mx-1">
    <p-button [disabled]="(securityProfileChanged$ | async) !== true" (click)="selectSecurityProfile()" label="Save" />
  </div>
</div>
